import clsx from 'clsx';
import React, { forwardRef } from 'react';
import * as RLabel from '@radix-ui/react-label';
import { label as labelClass } from './label.module.css';
export const Label = forwardRef(({ className, children, size = 14, style, ...props }, forwardedRef) => {
    const cssVars = {
        '--label-size': size
    };
    return (React.createElement(RLabel.Root, { ref: forwardedRef, className: clsx(labelClass, className), "data-label-size": size, style: { ...cssVars, ...style }, ...props }, children));
});
Label.displayName = 'Label';
